import React, {useContext, useState} from 'react';
import {Context} from "../store/reducer";

/**
 * 90_16_5 盛り土の第4条1項の同意ウィンドウ
 * 
 * @returns 
 */
const Component = () => {

    const { state, dispatch } = useContext(Context);
    let [isOpened, setIsOpened] = useState(true);

    /**
     * 同意した場合はフラグをtrueにする。
     */
    const agree = () => {

        dispatch({
            type    : 'SET_MODAL_AGREE',
            category: "vis_90_16_5"
        })
        
        setIsOpened(false)
    }
    
    const disAgree = () => {
        setIsOpened(false)
    }

    return (isOpened && <>
        <div class="modal-first">
            <div class="modal-first-inner">

                <h3 className="u-fs-16 u-txt-c u-lh-sm">「宅地造成等工事規制区域」について</h3>
                <h3 className="u-fs-16 u-txt-c u-lh-sm">「特定盛土等規制区域」について</h3>
                <h3 className="u-fs-16 u-txt-c u-lh-sm">「許可盛土等（法12条第1項・30条第1項）」について</h3>
                <h3 className="u-fs-16 u-txt-c u-lh-sm">「届出盛土等（法21条第1項・40条第1項）」について</h3>
                <h3 className="u-fs-16 u-txt-c u-pb-xs u-lh-sm">「既存盛土等(法第4条第1項)」について</h3>

                <section className="u-pb-xs">
                    <p>
                        宅地造成及び特定盛土等規制法（以下、「盛土規制法」という）では、
                        規制区域内の盛土等が行われた土地(過去の盛土等を含む)について、
                        土地所有者等が常に安全な状態に維持することが定められています。
                        土地所有者等の方々におかれましては、盛土等の安全確保に努めてください。
                    </p>
                </section>

                <section className="u-pb-xs">
                    <p>
                        ※注意<br />
                        こちらでは盛土規制法に係るデータについて、県内市町のうち広島市、呉市、福山市以外のデータを表示しています。
                        表示していない３市においても盛土規制法に係る区域指定等を行っていますので、次のURL等でご確認ください。
                    </p>
                </section>

                <section className="u-pb-xs">
                    <p>〇関連情報</p>
                    <ul>
                        <li>
                            広島市（盛土規制法の運用について）：
                            <a href="https://www.city.hiroshima.lg.jp/business/kenchiku/1021566/1036793/index.html" target="_blank" rel="noopener noreferrer">https://www.city.hiroshima.lg.jp/business/kenchiku/1021566/1036793/index.html</a>
                        </li>
                        <li>
                            呉市（都市計画課）：
                            <a href="https://www.city.kure.lg.jp/soshiki/49/" target="_blank" rel="noopener noreferrer">https://www.city.kure.lg.jp/soshiki/49/</a>
                        </li>
                        <li>
                            福山市（宅地造成及び特定盛土等規制法に基づく許可申請等の手引き）：
                            <a href="https://www.city.fukuyama.hiroshima.jp/uploaded/attachment/316364.pdf" target="_blank" rel="noopener noreferrer">https://www.city.fukuyama.hiroshima.jp/uploaded/attachment/316364.pdf</a>
                        </li>
                    </ul>
                </section>


                <p className="u-txt-c" onClick={agree} style={{ cursor: 'pointer' }} ><span style={{"text-decoration": "underline"}}>閉じる</span></p>
            </div>
        </div>
    </>);
}

export default Component
